export const NEW_PUBLIC_PORTAL_LOGIN_ENABLED_FLAG = 'new-public-portal-login';
export const ANG_SEARCH_ENABLED_FLAG = 'ang-search-enabled';
export const API_METRICS_DASHBOARD_ENABLED_FLAG =
  'deprecation-api-dashboard-metrics';
export const ASSET_CARD_ENABLED = 'ang-search-enabled';
export const NOTEBOOK_WORKERS_ENABLED = 'notebook-workers-enabled';
export const SNAPSHOTS_ENABLED_FLAG = 'snapshots-enabled';
export const CONSISTENT_NAVIGATION_ENABLED = 'consistent-navigation-enabled';
export const CONSISTENT_NAVIGATION_PHASE_2_ENABLED =
  'consistent-navigation-phase-2-enabled';
export const VERSION_AGNOSTIC_ENABLED = 'version-agnostic-enabled';
export const OAS_3_NOT_FULLY_SUPPORTED_ENABLED =
  'oas-3-not-fully-supported-enabled';
export const OAS_3_PHASE_2_ENABLED = 'oas-3-phase-2-enabled';
export const PEREGRINE_ENABLED = 'peregrine-enabled';
export const APIC_PRE_RELEASE_ENABLED = 'apic-pre-release-enabled';
export const ASSETS_LIMITS_ENABLED = 'assets-limit-enabled';
export const CUSTOM_ONBOARDING_ENABLED = 'custom-onboarding-enabled';
export const ONE_TRUST_ENABLED = 'one-trust-enabled';
export const ONE_TRUST_PRODUCTIVE_SCRIPT = 'one-trust-productive-script';
export const PUBLISH_FORM_V2_ENABLED = 'publish-form-v2-enabled';
export const PORTAL_RE_ARCHITECTURE_ENABLED = 'portal-re-architecture-enabled';
export const PUBLIC_PORTAL_PIRA_ENABLED = 'public-portal-pira-enabled';
export const ASSETS_DEFINITIONS_VERSION = 'assets-definitions-version';
export const FEDERATED_ASSETS_DEFINITIONS_ENABLED =
  'federated-assets-definitions-enabled';
export const LOGIN_CSRF_PROTECTION_ENABLED = 'login-csrf-protection-enabled';
export const COMMUNICATION_ASSETS_ENABLED = 'communication-assets-enabled';
export const GLOBAL_ANG_SEARCH_ENABLED = 'global-ang-search-enabled';
export const REUSE_METRICS_ENABLED = 'reuse-metrics-enabled';
export const ANG_DEFAULT_ENABLED = 'ang-default-enabled';
export const PORTAL_SEARCH_ENABLED = 'portal-search-enabled';
